export enum MiddlewareAction {
  RedirectToRoute = 'app/redirectToRoute',
}
